import { render, staticRenderFns } from "./ClientRegistration.vue?vue&type=template&id=84f423d6&"
import script from "./ClientRegistration.vue?vue&type=script&lang=js&"
export * from "./ClientRegistration.vue?vue&type=script&lang=js&"
import style0 from "./ClientRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClientRegistration.vue"
export default component.exports